let IS_OPUS_SUPPORTED = true;
if(typeof document !== 'undefined') {
  const audio = document.createElement('audio');
  IS_OPUS_SUPPORTED = !!(audio.canPlayType && audio.canPlayType('audio/ogg;').replace(/no/, ''))/*  && false */;
}

export default IS_OPUS_SUPPORTED;
